/**
 * Theme de Material UI sincronizado con los design tokens.
 */
import { createTheme } from '@mui/material/styles';
import { designTokens } from './design-tokens';

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: designTokens.colors.primary.DEFAULT,
      dark: designTokens.colors.primary.hover,
      light: designTokens.colors.primary.light,
    },
    secondary: {
      main: designTokens.colors.secondary.DEFAULT,
      dark: designTokens.colors.secondary.hover,
      light: designTokens.colors.secondary.light,
      contrastText: designTokens.colors.secondary.darkText,
    },
    success: {
      main: designTokens.colors.success.DEFAULT,
      light: designTokens.colors.success.light,
    },
    error: {
      main: designTokens.colors.error.DEFAULT,
      light: designTokens.colors.error.light,
    },
    warning: {
      main: designTokens.colors.warning.DEFAULT,
      light: designTokens.colors.warning.light,
    },
    background: {
      default: designTokens.colors.bg.layout,
    },
  },
  typography: {
    fontFamily: designTokens.typography.fontFamily,
    h1: { fontSize: designTokens.typography.h1, fontWeight: 600 },
    h2: { fontSize: designTokens.typography.h2, fontWeight: 600 },
    h3: { fontSize: designTokens.typography.h3, fontWeight: 600 },
    h4: { fontSize: designTokens.typography.h4, fontWeight: 600 },
    body1: { fontSize: designTokens.typography.body1 },
    body2: { fontSize: designTokens.typography.body2 },
    caption: { fontSize: designTokens.typography.caption },
  },
  shape: {
    borderRadius: 6,
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
      },
    },
  },
});
